import { useState, useCallback } from 'react'
import { appsyncQuery } from '../../api/appsync-client.js'

const GET_PREVIOUS_OPEN_ITEMS = `
  query GetPreviousOpenItems($sessionId: ID!) {
    getPreviousOpenItems(sessionId: $sessionId) {
      text
      priority
      addedBy
    }
  }
`

export function useImportOpenItems({ sessionId }) {
  const [loading, setLoading] = useState(false)

  const fetchOpenItems = useCallback(async () => {
    setLoading(true)
    try {
      const data = await appsyncQuery(GET_PREVIOUS_OPEN_ITEMS, { sessionId })
      return data.getPreviousOpenItems || []
    } finally {
      setLoading(false)
    }
  }, [sessionId])

  return { fetchOpenItems, loading }
}
